import { render, staticRenderFns } from "./ArchivedTab.vue?vue&type=template&id=19271c16&scoped=true&"
import script from "./ArchivedTab.vue?vue&type=script&lang=js&"
export * from "./ArchivedTab.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedTab.vue?vue&type=style&index=0&id=19271c16&prod&lang=scss&scoped=true&"
import style1 from "./ArchivedTab.vue?vue&type=style&index=1&id=19271c16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19271c16",
  null
  
)

export default component.exports